import { ResponsiveView } from '@gower/react-ui/template/responsive-view';
import { provider } from './store';
import { CalculatorDesktop } from './desktop';
import { CalculatorMobile } from './mobile';

export const CalculatorView = provider( () => {

    return <>
        <ResponsiveView
            desktop={CalculatorDesktop}
            mobile={CalculatorMobile}
        />
    </>;
} );
